module.exports = __webpack_public_path__ + "static/media/me-avatar.796c5d4f.svg";